var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUaeFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2122_7869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0.333313V3.44442H0V0.333313H14Z",
    fill: "#479951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3.4444V6.5555H0V3.4444H14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.55554V9.66665H0V6.55554H14Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.11111 9.66664H0V0.333313H3.11111V9.66664Z",
    fill: "#E74C3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2122_7869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 9.33333,
    fill: "white",
    transform: "translate(0 0.333313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUaeFlag);
export default __webpack_public_path__ + "static/media/uae-flag.77b522a2a495ed55dbb8f56c12435487.svg";
export { ForwardRef as ReactComponent };